
import React from 'react';

export default function ProductsSection() {
  const products = [
    {
      image: 'https://static.readdy.ai/image/019f363305df1fedef8ad80ba416d27a/8610b942c4d96fe16e413180248bc1d9.png',
      title: 'Beauty Products',
      description:
        'XJ BEAUTY - innovative beauty and personal care global manufacturer',
      hasWebsite: true,
      websiteUrl: 'https://www.xj-beauty.com',
    },
    {
      image:
        'https://images.squarespace-cdn.com/content/v1/664c7ad1bcc10d55948aedd4/9e2afc19-3bc1-452a-a2b2-3a8ce94c2b36/p1.jpg',
      title: 'Daily General Merchandise',
      description:
        'Essential everyday items for retail chains and consumers worldwide',
      hasWebsite: false,
    },
    {
      image:
        'https://images.squarespace-cdn.com/content/v1/664c7ad1bcc10d55948aedd4/423b1026-d5c1-437b-83bf-17314d5d9ed5/p2.jpg',
      title: 'Cutlery Items',
      description:
        'High-quality plastic and wooden cutlery solutions for various applications',
      hasWebsite: false,
    },
    {
      image:
        'https://public.readdy.ai/ai/img_res/623a12cd06ef1728813f8bfd2e3147a5.jpg',
      title: 'Alkaline Batteries',
      description:
        'High-performance alkaline batteries for various electronic devices and applications',
      hasWebsite: true,
      websiteUrl: 'https://www.xj-battery.com',
    },
    {
      image:
        'https://images.squarespace-cdn.com/content/v1/664c7ad1bcc10d55948aedd4/2fefb863-a9e4-4f38-b47f-caf6b1d20668/p4.jpg',
      title: 'Food Products',
      description:
        'Premium food items from South Korea, Japan and other global sources',
      hasWebsite: false,
    },
    {
      image:
        'https://images.squarespace-cdn.com/content/v1/664c7ad1bcc10d55948aedd4/a144bcf5-766d-401a-9662-2d905f95783b/p5.jpg',
      title: 'Kitchenware',
      description:
        'Professional and consumer kitchen equipment and accessories',
      hasWebsite: false,
    },
  ];

  /** Opens a new tab/window with the given URL.
   *  Includes basic validation to avoid opening empty or malformed URLs.
   */
  const handleWebsiteClick = (url: string) => {
    try {
      const validatedUrl = new URL(url);
      window.open(validatedUrl.toString(), '_blank', 'noopener,noreferrer');
    } catch (error) {
      console.error('Invalid URL provided to handleWebsiteClick:', url, error);
    }
  };

  return (
    <section id="products" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Diverse Product Portfolio
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From everyday essentials to specialized equipment, we source quality
            products across multiple categories
          </p>
        </div>

        {/* Product Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow"
            >
              <div className="aspect-w-16 aspect-h-12 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {product.title}
                </h3>
                <p className="text-gray-600 mb-4">{product.description}</p>

                {product.hasWebsite && product.websiteUrl && (
                  <button
                    onClick={() => handleWebsiteClick(product.websiteUrl!)}
                    className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-7
                    00 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Visit Website
                    <div className="ml-2 w-4 h-4 flex items-center justify-center">
                      <i className="ri-external-link-line"></i>
                    </div>
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Call‑to‑Action */}
        <div className="text-center mt-12">
          <button
            onClick={() =>
              document
                .getElementById('services')
                ?.scrollIntoView({ behavior: 'smooth' })
            }
            className="inline-flex items-center px-8 py-4 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            Explore All Products
            <div className="ml-2 w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
}
